module.exports = {
	"notification.message": "Wix.com používá soubory cookies, aby vám poskytl nejlepší možný zážitek.",
	"notification.got.it": "Chápu",
	"notification.more.info": "Zjistit více"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_cs.json
// module id = 36
// module chunks = 0